interface Point { x: number; y: number; }

/** The original circular connector, with a bounded solution for long or coincident spans. */
const connectorArc = (start: Point, end: Point, preferredRadius: number, high: boolean, margin: number) => {
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    if (!Number.isFinite(distance) || distance === 0 || preferredRadius <= 0) return null;
    const radius = Math.max(preferredRadius, distance / 2);
    const angle = 2 * Math.asin(Math.min(1, distance / (2 * radius)));
    const offset = Math.sqrt(Math.max(0, radius * radius / (distance * distance) - 0.25));
    const direction = high ? 1 : -1;
    const center = {
        x: (start.x + end.x) / 2 - direction * dy * offset,
        y: (start.y + end.y) / 2 + direction * dx * offset,
    };
    const origin = high ? start : end;
    const startAngle = Math.atan2(origin.y - center.y, origin.x - center.x);
    const inset = Math.max(0, Math.min(margin, angle / 2));
    return { center, radius, startAngle: startAngle + inset, endAngle: startAngle + angle - inset };
};

export default connectorArc;
